import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoOutlineIcon, Inscription, WarningCard } from '@common-fe/common-fe';

interface Props {
  accountNames: string[];
}

const AccountsToPayMessage: React.FC<Props> = ({ accountNames }) => {
  const { t } = useTranslation();

  const title = useMemo(() => {
    const mainAccount = accountNames?.[0];
    const additionalAccounts = [...accountNames]?.splice(1, accountNames?.length);
  
    if (accountNames?.length === 1) {
      return (
        <Inscription data-testId="accounts-to-pay_title">
          {t('Based on the service date and description, this claim will pay from your ')}
          <Inscription data-testId="accounts-to-pay_account-name" weight={700}>
            {mainAccount}.
          </Inscription>
        </Inscription>
      );
    }

    return (
      <Inscription data-testId="accounts-to-pay_title">
        {t('Based on the service date and description, this claim will pay from your ')}
        <Inscription data-testId="accounts-to-pay_account-name" weight={700}>
          {mainAccount}
        </Inscription>.
        {t(' If funds are not available, the claim will pay from your additional accounts: ')}
        {additionalAccounts?.map((accountName, index) => (
          <>
            <Inscription key={accountName} data-testId="accounts-to-pay_account-name" weight={700}>
              {accountName}
            </Inscription>
            {index === additionalAccounts.length - 1 ? '' : ', '}
          </>
        ))}.
      </Inscription>
    );
  }, [t, accountNames]);

  return (
    <WarningCard
      testId="accounts-to-pay"
      icon={<InfoOutlineIcon color="info" />}
      title={title}
      backgroundColor="infoContainer"
      borderColor="infoBorder"
      topBorderColor="transparent"
      containerProps={{
        pad: { horizontal: 'spacing24', vertical: 'spacing16' },
        round: 'container2Round',
      }}
    />
  );
};

export default AccountsToPayMessage;
